import { type HTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './PageHeader.module.scss'

export interface PageHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Uppercase mono caption above the title (e.g. "Sistema de Ranking"). */
  eyebrow?: ReactNode
  title: ReactNode
  description?: ReactNode
  /** Right-side actions (buttons, menus). */
  actions?: ReactNode
}

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  className,
  ...rest
}: PageHeaderProps) {
  return (
    <header className={cn(styles.header, className)} {...rest}>
      <div className={styles.text}>
        {eyebrow ? <div className={styles.eyebrow}>{eyebrow}</div> : null}
        <h1 className={styles.title}>{title}</h1>
        {description ? <p className={styles.description}>{description}</p> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  )
}
